<template>

<com-section v-on:back="$emit('back')" v-on:next="$emit('next')" :section="section" :hide-foot="true">

	<slot></slot>

	<template v-if="!subsection">

		<div class="mybonehealth-sections no-print">

			<div class="mybonehealth-section" :class="{'is-locked': isLocked(item), 'is-static': isDecisionLocked(item)}" v-for="item in visibleSubsections" :key="item.key" v-on:click="onSubsectionClick(item)">

				<div class="mybonehealth-section-icon" :class="{'is-complete': completed[item.key]}">
				<i class="fa-solid" :class="completed[item.key] ? 'fa-check' : item.icon"></i>
			</div>

				<div class="mybonehealth-section-body">
					<div class="mybonehealth-section-title">{{ section[item.key] ? (section[item.key].title || item.label) : item.label }}</div>
					<div class="mybonehealth-section-note" v-if="isResultsLocked(item)">If you would like to see a personalised &lsquo;My Bone Health&rsquo; section please <span class="mybonehealth-section-link">enter your health information here</span>.</div>
					<div class="mybonehealth-section-note" v-if="isDecisionLocked(item)">This section is only available when you access the tool using a code from your healthcare professional.</div>
				</div>

				<div class="mybonehealth-section-chevron" v-if="!isLocked(item)"></div>

			</div>

		</div>

		<div class="mybonehealth-actions no-print">
			<div class="mybonehealth-actions-note">If you would like to print a copy of the information in this section please click &lsquo;print my bone health&rsquo;</div>
			<button class="mybonehealth-action" v-on:click="onPrint"><i class="fa-solid fa-print"></i> Print my bone health</button>
		</div>

		<vue-html2pdf ref="html2Pdf" :enable-download="false" :manual-pagination="true" :pdf-content-width="'100%'" :html-to-pdf-options="pdfOptions" v-on:beforeDownload="onPDFGenerating($event)" v-on:hasDownloaded="onPDFComplete($event)">

			<section slot="pdf-content">

				<div class="mybonehealth-print">

					<div class="mybonehealth-print-title">My Bone Health</div>

					<template v-if="hasData">
						<div class="mybonehealth-print-section">
							<div class="mybonehealth-print-section-title">My Results</div>
							<com-results :data="section.results" />
						</div>
					</template>

					<div class="mybonehealth-print-section" v-if="quizQuestions.length">
						<div class="mybonehealth-print-section-title">Test My Knowledge</div>
						<div class="mybonehealth-print-quiz-item" v-for="(q, index) in quizQuestions" :key="q.id">
							<div class="mybonehealth-print-quiz-q">{{ index + 1 }}. {{ q.text }}</div>
							<div class="mybonehealth-print-quiz-a">Answer: <strong>{{ q.answer ? 'True' : 'False' }}</strong></div>
							<div class="mybonehealth-print-quiz-e" v-if="q.explanation" v-html="q.explanation"></div>
						</div>
					</div>

					<div class="mybonehealth-print-section" v-if="section.decision">
						<div class="mybonehealth-print-section-title">My Medicine Decision</div>
						<com-decision :data="section.decision" />
					</div>

					<div class="mybonehealth-print-section" v-if="patientNotes">
						<div class="mybonehealth-print-section-title">My Questions & Notes</div>
						<p>{{ patientNotes }}</p>
					</div>

					<div class="mybonehealth-print-section" v-if="section.actionplan">
						<div class="mybonehealth-print-section-title">My Action Plan</div>
						<com-actionplan :data="section.actionplan" />
					</div>

				</div>

			</section>

		</vue-html2pdf>

	</template>

	<template v-if="subsection">

		<com-segment :segment="subsection" :section="section" :title="subsectionTitle" :icon="subsectionIcon" v-on:close="onSubsectionClose">

			<template v-slot:subtitle>
				<div class="mybonehealth-quiz-viewall" v-if="subsection === 'quiz'" v-on:click="openQuizAnswers">If you would like to view all the answers <span class="mybonehealth-quiz-viewall-link">click here</span></div>
			</template>

			<com-results v-if="subsection === 'results'" :data="section.results" />
			<com-quiz ref="quiz" v-if="subsection === 'quiz'" :data="section.quiz" v-on:complete="onComplete('quiz')" />
			<com-decision v-if="subsection === 'decision'" :data="section.decision" v-on:complete="onComplete('decision')" v-on:close="onSubsectionClose" />
			<com-notes v-if="subsection === 'notes'" :data="section.notes" v-on:complete="onComplete('notes')" v-on:close="onSubsectionClose" />
			<com-actionplan v-if="subsection === 'actionplan'" :data="section.actionplan" v-on:complete="onComplete('actionplan')" v-on:close="onSubsectionClose" />

		</com-segment>

	</template>

</com-section>

</template>

<script>

import comSection from '@/components/tool/common/Section'
import comSegment from './improve/Segment'

import comResults from './mybonehealth/Results'
import comQuiz from './mybonehealth/Quiz'
import comDecision from './mybonehealth/Decision'
import comNotes from './mybonehealth/Notes'
import comActionplan from './mybonehealth/Actionplan'

import VueHtml2pdf from 'vue-html2pdf'

export default {

	props: ['section'],

	components: {
		VueHtml2pdf,
		'com-section': comSection,
		'com-segment': comSegment,
		'com-results': comResults,
		'com-quiz': comQuiz,
		'com-decision': comDecision,
		'com-notes': comNotes,
		'com-actionplan': comActionplan
	},

	data: function() {

		var initial = sessionStorage.getItem('ifrap_initial_subsection')
		if (initial) sessionStorage.removeItem('ifrap_initial_subsection')

		return {
			subsection: initial || false,
			completed: {},
			is: {
				printing: false
			},
			pdfOptions: {
				margin: [12, 12, 12, 12],
				image: { type: 'jpeg', quality: 0.98 },
				enableLinks: false,
				html2canvas: { scale: 2, useCORS: true },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
				pagebreak: { mode: ['css', 'legacy'], avoid: '.mybonehealth-print-section' }
			},
			subsections: [
				{ key: 'results', label: 'My results', icon: 'fa-chart-line' },
				{ key: 'quiz', label: 'Test my knowledge', icon: 'fa-question' },
				{ key: 'decision', label: 'My medicine decision', icon: 'fa-scale-balanced' },
				{ key: 'notes', label: 'My questions & notes', icon: 'fa-pen' },
				{ key: 'actionplan', label: 'My action plan', icon: 'fa-clipboard-check' }
			]
		}

	},

	computed: {

		visibleSubsections: function() {

			// Patient: 'My results' is always listed; with no personal data
			// (browse / general info mode) it shows locked with a prompt to
			// enter health information. Clinician keeps the original behaviour
			// of hiding 'My results' when there is no data.
			return this.$_.filter(this.subsections, function(item) {
				if (item.key === 'results' && !this.hasData && !this.$isPatient) return false
				return true
			}.bind(this))

		},

		hasData: function() {

			return this.frax('major') !== 0

		},

		patientNotes: function() {

			return localStorage.getItem('ifrap_patient_notes') || ''

		},

		quizQuestions: function() {

			return (this.section.quiz && this.section.quiz.questions) || []

		},

		subsectionIcon: function() {

			var item = this.$_.findWhere(this.subsections, { key: this.subsection })
			return item ? item.icon : ''

		},

		subsectionTitle: function() {

			if (!this.subsection || !this.section[this.subsection]) return ''
			return this.section[this.subsection].title || ''

		}

	},

	methods: {

		isResultsLocked: function(item) {

			return this.$isPatient && item.key === 'results' && !this.hasData

		},

		isDecisionLocked: function(item) {

			// My medicine decision is only available when the tool was entered
			// with a code / direct from the clinician side (prepopulated mode).
			return this.$isPatient && item.key === 'decision' && this.$store.getters['session/patient/mode'] !== 'prepopulated'

		},

		isLocked: function(item) {

			return this.isResultsLocked(item) || this.isDecisionLocked(item)

		},

		onSubsectionClick: function(item) {

			if (this.isResultsLocked(item)) {

				this.goToYourInformation()
				return

			}

			if (this.isDecisionLocked(item)) return

			this.subsection = item.key

		},

		goToYourInformation: function() {

			// Switch to manual mode (equivalent to entering via option 2) and
			// jump to the data-entry section so the user can add their details.
			this.$store.commit('session/patient/mode', 'manual')

			var entry = this.$_.find(this.$store.getters['data/aid/sections/active'], function(s) {
				return s.type === 'entry'
			})

			if (entry) this.$store.commit('session/section/current', entry.id)

		},

		onComplete: function(key) {

			this.$set(this.completed, key, true)

		},

		openQuizAnswers: function() {

			if (this.$refs.quiz) this.$refs.quiz.openAnswers()

		},

		onSubsectionClose: function() {

			if (this.subsection === 'results') this.$set(this.completed, 'results', true)
			this.subsection = false

		},

		onPrint: function() {

			// Render the print section to a PDF (off-screen) and open it for
			// printing, mirroring the clinician record print flow. Printing the
			// live SPA directly renders blank because of its fixed-position,
			// overflow-hidden panes.
			this.is.printing = true

			this.$refs.html2Pdf.generatePdf()

		},

		onPDFGenerating: async function(e) {

			if (this.is.printing) {

				await e.html2pdf().set(e.options).from(e.pdfContent).toPdf().get('pdf').then(function(pdf) {

					var win = window.open(pdf.output('bloburl'), '_blank')
					win.focus()
					win.print()

					this.is.printing = false

				}.bind(this))

			}

		},

		onPDFComplete: function() {

			this.is.printing = false

		}

	}

}

</script>

<style scoped>

.mybonehealth-sections {
	display: flex;
	flex-direction: column;
}

.mybonehealth-section {
	display: flex;
	align-items: center;
	padding: 20px 24px;
	border-bottom: 1px solid #e0e0e0;
	cursor: pointer;
	transition: all 300ms ease-in-out;
}

.mybonehealth-section:first-child { border-top: 1px solid #e0e0e0; }
.mybonehealth-section:hover { background-color: #f8f8f8; }

.mybonehealth-section-icon {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
	margin-right: 20px;
	border-radius: 50%;
	background-color: var(--aid-color);
	display: flex;
	align-items: center;
	justify-content: center;
}

.mybonehealth-section-icon i { color: #343434; font-size: 18px; }
.mybonehealth-section-icon.is-complete { background-color: #4CAF50; }
.mybonehealth-section-icon.is-complete i { color: #fff; }

.mybonehealth-section-body { flex: 1; }

.mybonehealth-section-title {
	font-size: 20px;
	font-weight: 600;
	color: #343434;
	line-height: 26px;
}

.mybonehealth-section.is-static { cursor: default; }
.mybonehealth-section.is-static:hover { background-color: transparent; }

.mybonehealth-section.is-locked .mybonehealth-section-icon {
	background-color: #d6d6d6;
}

.mybonehealth-section.is-locked .mybonehealth-section-icon i {
	color: #fff;
}

.mybonehealth-section.is-locked .mybonehealth-section-title {
	color: #9b9b9b;
}

.mybonehealth-section-note {
	margin-top: 6px;
	font-size: 15px;
	font-weight: 400;
	color: #666;
	line-height: 22px;
}

.mybonehealth-section-link {
	color: var(--aid-color);
	font-weight: 600;
	text-decoration: underline;
}

.mybonehealth-quiz-viewall {
	font-size: 14px;
	color: #666;
	line-height: 20px;
	margin-top: 6px;
	cursor: pointer;
}

.mybonehealth-quiz-viewall-link {
	color: var(--aid-color);
	font-weight: 600;
	text-decoration: underline;
}

.mybonehealth-section-chevron {
	width: 10px;
	height: 10px;
	flex-shrink: 0;
	margin-left: 16px;
	border-right: 2px solid #ccc;
	border-bottom: 2px solid #ccc;
	transform: rotate(-45deg);
	transition: all 300ms ease-in-out;
}

.mybonehealth-section:hover .mybonehealth-section-chevron { border-color: var(--aid-color); }

.mybonehealth-actions {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	margin-top: 32px;
	justify-content: center;
}

.mybonehealth-actions-note {
	font-size: 15px;
	font-weight: 400;
	color: #666;
	line-height: 22px;
	text-align: center;
	max-width: 480px;
}

.mybonehealth-action {
	padding: 12px 24px;
	border-radius: 24px;
	font-size: 14px;
	font-weight: 600;
	border: 2px solid #e0e0e0;
	background-color: transparent;
	color: #343434;
	cursor: pointer;
	transition: all 300ms ease-in-out;
}

.mybonehealth-action i { margin-right: 8px; }

.mybonehealth-action:hover {
	border-color: var(--aid-color);
	background-color: var(--aid-color);
}


</style>

<style>

.segment-head-icon i {
	font-size: 32px;
	color: #343434;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.mbh-save-button {
	padding: 12px 32px;
	border-radius: 24px;
	font-size: 14px;
	font-weight: 600;
	background-color: var(--aid-color);
	color: #343434;
	border: none;
	cursor: pointer;
	text-transform: uppercase;
	letter-spacing: 1px;
}

.mbh-save-button:hover { filter: brightness(90%); }

.mbh-save-button.is-disabled {
	opacity: 0.5;
	cursor: default;
	pointer-events: none;
}

/* The print section is rendered off-screen by vue-html2pdf and captured to a
   PDF, so these styles apply on screen (not under @media print). */
.mybonehealth-print {
	background: #fff;
}

/* The skeleton graphic sits absolutely over the two result quadrants on
   screen; it should never appear on the printout. */
.mybonehealth-print .mbh-results-skeleton {
	display: none;
}

.mybonehealth-print-title {
	font-size: 24px;
	font-weight: 600;
	color: #343434;
	margin-bottom: 24px;
	padding-bottom: 12px;
	border-bottom: 3px solid #343434;
}

.mybonehealth-print-section {
	margin-bottom: 24px;
	page-break-inside: avoid;
}

.mybonehealth-print-section-title {
	font-size: 18px;
	font-weight: 600;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 12px;
	padding-bottom: 8px;
	border-bottom: 1px solid #ccc;
}

.mybonehealth-print-section p {
	font-size: 14px;
	line-height: 20px;
	color: #343434;
}

.mybonehealth-print-quiz-item {
	margin-bottom: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid #eee;
	page-break-inside: avoid;
}

.mybonehealth-print-quiz-item:last-child { border-bottom: none; }

.mybonehealth-print-quiz-q {
	font-size: 15px;
	font-weight: 600;
	color: #343434;
	line-height: 22px;
	margin-bottom: 6px;
}

.mybonehealth-print-quiz-a {
	font-size: 14px;
	color: #343434;
	margin-bottom: 6px;
}

.mybonehealth-print-quiz-e {
	font-size: 14px;
	line-height: 20px;
	color: #666;
}

</style>
